// from elemental ui

export const breakpoint = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1200
};

export const width = {
  container: 1440,
  gutter: 20
};

function perc(n) {
  return (n * 100) + '%';
}

function denominators (n) {
  for (var d = 2; d <= 30; d++) {
    if (n < d) {
      exports.fractions[n + '/' + d] = perc(n / d);
    }
  }
}

export const fractions = {
  '1': '100%',
};

for (var numerator = 1; numerator <= 29; numerator++) {
  denominators(numerator);
}



// WEBPACK FOOTER //
// ./src/components/common/constants.js